import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {Avatar} from "@mui/material";
import {Link} from "react-router-dom";
import React from "react";
import Constants from "../../../config/constants";

const RouteAvatar = ({t, item = null, types: propsTypes =  [], size = null, url = null, beforeRedirect = () => {}}) => {
    let avatarProps = {};

    if (url !== null) {
        avatarProps.component = Link;
        avatarProps.to = url;
    }
    let types = propsTypes;
    if (!Array.isArray(types) || types.length === 0) {
        if (item?.types) {
            types = item?.types;
        } else {
            types = [];
        }
    }

    let avatarColorName = item?.avatarColorName;
    if (types.length === 1) {
        avatarColorName = types;
    } else if (types.length > 1) {
        avatarColorName = 'mixte';
    }

    let style = {textShadow: "1px 1px 1px #333" };
    if (size === "small") {
        style.width = '24px';
        style.height = '24px';
    }

    return (
        <Avatar aria-label="recipe" className={avatarColorName}
                       style={style}
                       {...avatarProps}
                       onClick={beforeRedirect}
        >
            {item?.types && item.types.length > 1 && <><div style={{
                fontSize: (size === "small" ? "10px" : "14px")
            }}>{t('searchResults.avatar.cliff')}</div>
                {/*{size !== "small" && <br/>}*/}
                <div style={{
                    fontSize: (size === "small" ? "10px" : "14px")
                }}>
                    {item.types.includes(Constants.BOULDER) && <>{t('searchResults.avatar.boulder')}</>}
                    {item.types.includes(Constants.MULTIPITCH) && item.types.includes(Constants.BOULDER) && <>/</>}
                    {item.types.includes(Constants.MULTIPITCH) && <>{t('searchResults.avatar.multipitch')}</>}

                </div></>}
            {item?.types?.length === 1 && <div style={{
                fontSize: (size === "small" ? "11px" : "14px"),
            }}>{t('searchResults.avatar.' + item.types[0] )}</div>}
            {item?.types?.length !== 1 && item?.type === Constants.MULTIPITCH && <div style={{
                fontSize: (size === "small" ? "11px" : "14px"),
            }}>{t('searchResults.avatar.multipitch' )}</div>}
        </Avatar>
    );
}

export default compose(
    withTranslation()
)(RouteAvatar);